import React, { useEffect, useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import moment from 'moment';
import { styledTable, styledTableHeading, tableIcons } from '../../../helpers';
import { dateRenderer, dateTimeRenderer, floatRenderer } from '../../../services/formatSvc';
import useAPI from '../../../hooks/useAPI';
import {
  localization, modifyDefaultOptions, options, tableIconsModified,
} from '../../../helpers/table';

import DownloadLink from '../../../components/common/DownloadLink';
import LoadingTable from '../../../components/table/LoadingTable';

export default function TabSOuts() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const api = useAPI();

  useEffect(async () => {
    const result = await api.get('/exch/souts');
    setIsLoaded(true);
    setData(result);
  }, []);

  const columns = [
    { title: 'Номер закупки', field: 'num', filterCellStyle: { width: '30px' } },
    { title: 'GUID закупки', field: 'guid' },
    { title: 'Наименование закупки', field: 'name', filterCellStyle: { width: '100px' } },
    { title: 'Оценочная стоимость', field: 'buySum', render: (rowData) => floatRenderer(rowData.buySum) },
    { title: 'ЦФО', field: 'cfo' },
    { title: 'Аналитический код КПС', field: 'kpsCode' },
    { title: 'Статус', field: 'status' },
    { title: 'Номер протокола', field: 'approvalNum' },
    {
      title: 'Дата протокола', field: 'approvalDate', type: 'date', render: (rowData) => dateRenderer(rowData.approvalDate),
    },
    { title: 'Руководитель проекта', field: 'projHeadName' },
    {
      title: 'Принято к отправке', field: 'chunk.dateIn', type: 'date', render: (rowData) => moment.utc(rowData.outChunk.dateIn).format('DD.MM.YYYY HH:mm:ss'),
    },
    {
      title: 'Дата отправки', field: 'chunk.dateOut', type: 'date', render: (rowData) => (rowData.outChunk.dateOut ? moment.utc(rowData.outChunk.dateOut).format('DD.MM.YYYY HH:mm:ss') : null),
    }, // ??
    { title: 'Комментарий экспортера', field: 'outComment' },
  ];

   return (
    <section className="tab-agreement">
      <div style={styledTable}>
        <LoadingTable loadingObject={{isLoaded}}>
          <MaterialTable
            title={<h3 style={styledTableHeading}>Журнал отправки в 1С</h3>}
            options={modifyDefaultOptions({
              actionsColumnIndex: -1,
            })}
            actions={[
              (rowData) => ({
                icon: () => <DownloadLink url={`/exch/souts/${rowData.sOutChunkId}/json`} filename={`Protocol_${rowData.approvalNum}.json`}>JSON</DownloadLink>,
                tooltip: 'Загрузить JSON',
                // onClick: (event, row) => setRevisionModalReportId(row.id),
              }),
            ]}
            icons={tableIconsModified}
            localization={localization}
            columns={columns}
            data={data}
          />
        </LoadingTable>
      </div>
    </section>
  );
}
